import React from 'react';
import "../styles/pages/home.scss";
import whatspp_icon from '../../User/assets/icons/whatsapp.png'

const WhatsApp = () => {
    return (
        <React.Fragment>
            <a href="https://api.whatsapp.com/send?phone=9036074200" target="_blank" className="btn-whatsapp-pulse btn-whatsapp-pulse-border">
                <img src={whatspp_icon} alt="whatspp_icon" />
            </a>
        </React.Fragment>
    )
}

export default WhatsApp;